/**
 * Phase 8g — AL-Bild-Alias.
 *
 * Etliche Produktbilder tragen CH-Begriffe im DATEINAMEN
 * ("…-Schweiz-Twint-Bigfollow.ch_.png"). Die Datei-URL landet im
 * ausgelieferten HTML (img src, og:image, JSON-LD) und ist damit ein
 * sichtbarer CH-Rest auf bigfollow.al.
 *
 * Lösung ohne Eingriff in CH/AT/IT: die betroffenen Objekte wurden im
 * Bucket `product-images` zusätzlich unter `al/<neutraler-name>` abgelegt
 * (Edge Function `al-image-alias`, Originale bleiben unangetastet). Nur auf
 * sf='al' zeigen wir auf die Kopie.
 */

const MARKER = '/storage/v1/object/public/product-images/';
const RENDER_MARKER = '/storage/v1/render/image/public/product-images/';

/** Muss byte-identisch zur Kopier-Logik in `al-image-alias` sein. */
export function cleanImageName(name: string): string {
  let out = name;
  out = out.replace(/[-_]?twint/gi, '');
  out = out.replace(/[-_]?schweiz/gi, '');
  out = out.replace(/bigfollow\.ch_?/gi, 'bigfollow');
  out = out.replace(/[-_]{2,}/g, '-');
  out = out.replace(/-\./g, '.');
  return out;
}

/** Storefront-unabhängige Umschreibung; gibt die URL unverändert zurück,
 *  wenn der Dateiname keine CH-Begriffe enthält. */
export function alImageUrl(url: string | null | undefined): string {
  if (!url) return url ?? '';
  const marker = url.includes(MARKER) ? MARKER : url.includes(RENDER_MARKER) ? RENDER_MARKER : null;
  if (!marker) return url;
  const idx = url.indexOf(marker) + marker.length;
  const rest = url.slice(idx);
  const [path, query] = rest.split('?');
  if (path.startsWith('al/')) return url;
  const clean = cleanImageName(decodeURIComponent(path));
  if (clean === decodeURIComponent(path)) return url;
  return `${url.slice(0, idx)}al/${clean}${query ? `?${query}` : ''}`;
}

/** Aktive Storefront ohne React-Hook (identische Logik wie detectStorefront). */
function isAlHost(): boolean {
  if (typeof window === 'undefined') return false;
  const forced = (window as any).__BF_FORCE_SF__;
  if (forced) return forced === 'al';
  const h = (window.location.hostname || '').toLowerCase();
  return h === 'bigfollow.al' || h.endsWith('.bigfollow.al');
}

/** No-op ausserhalb von AL — CH/AT/IT bleiben byte-identisch. */
export function maybeAlImageUrl(url: string | null | undefined): string {
  if (!url) return url ?? '';
  return isAlHost() ? alImageUrl(url) : url;
}
